var isNil = function (v) { return ((v === null) || (v === undefined)); };
var patchElement = function (id) {
    return document.getElementById(id);
};
var callbackList = [];
var completeCallback = function (page) {
    if (callbackList[page])
        callbackList[page]();
};
var setCompleteCallback = function (page, f) {
    callbackList[page] = f;
};
export { isNil, patchElement, setCompleteCallback, completeCallback };
//# sourceMappingURL=utils.js.map